import _classCallCheck from "C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\repo\\tff2023\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import * as React from 'react';
import NavigationContext from './NavigationContext';

var SceneView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SceneView, _React$PureComponent);

  function SceneView() {
    _classCallCheck(this, SceneView);

    return _possibleConstructorReturn(this, _getPrototypeOf(SceneView).apply(this, arguments));
  }

  _createClass(SceneView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          screenProps = _this$props.screenProps,
          Component = _this$props.component,
          navigation = _this$props.navigation;
      return (
        /*#__PURE__*/
        React.createElement(NavigationContext.Provider, {
          value: navigation
        },
        /*#__PURE__*/
        React.createElement(Component, {
          screenProps: screenProps,
          navigation: navigation
        }))
      );
    }
  }]);

  return SceneView;
}(React.PureComponent);

export { SceneView as default };